import React from "react";
import { Grid2 as Grid } from "@mui/material";
import FormSelectField from "../../components/forms/fields/basic/SelectField";
import FormTextField from "../../components/forms/fields/basic/TextField";
import usePersonLogic from "../../hooks/logic/personLogic";

const PersonNameInternalEvidence: React.FC = () => {
  const {
    nameDesignationsReconstructionStatusEnum,
    nameDesignationsStatusEnum,
  } = usePersonLogic();
  return (
    <Grid container spacing={2}>
      <FormTextField
        name="attribute_pre"
        label="Name Attribute Pre"
        placeholder="Enter name attribute pre"
      />
      <FormTextField name="name" label="Name" placeholder="Enter name" />
      <FormTextField
        name="attribute_post"
        label="Name Attribute Post"
        placeholder="Enter name attribute post"
      />
      <FormSelectField
        name="reconstruction_status_type"
        label="Name Reconstruction Status Type"
        placeholder="Select reconstruction status type"
        useEnum={nameDesignationsReconstructionStatusEnum}
      />
      <FormSelectField
        name="status_type"
        label="Status Type"
        placeholder="Select status type"
        useEnum={nameDesignationsStatusEnum}
      />
    </Grid>
  );
};

export default PersonNameInternalEvidence;
